module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity12.538f2676.jpg";